import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import config from "src/config";
import {
  selectAppointmentUserAvatar,
  selectAppointmentUserIsDoctor,
  selectAppointmentUserName,
} from "@/store/features/appointment/selectors";
import { selectUserIsAdmin } from "@/store/features/user/selectors";
import { useAppSelector } from "@/store/hooks";
import { Avatar, Button } from "@/ui";
import { StyledUserInfo, StyledUserInfoWrapper } from "./styled";

const UserInfo: FC = () => {
  const { t } = useTranslation();

  const { id } = useParams();

  const isDoctor = useAppSelector(selectAppointmentUserIsDoctor);
  const isAdmin = useAppSelector(selectUserIsAdmin);
  const avatar = useAppSelector(selectAppointmentUserAvatar);
  const name = useAppSelector(selectAppointmentUserName);

  const url = useMemo(() => {
    if (isAdmin) {
      return `${config.doctor_url.replace('doctor', 'admin')}/appointments/${id}`;
    }

    if (isDoctor) {
      return `${config.doctor_url}/appointments/details/${id}`;
    }

    return `${config.patient_url}/appointments/${id}`;
  }, [id, isAdmin, isDoctor]);

  return (
    <StyledUserInfo>
      <StyledUserInfoWrapper>
        <Avatar size={80} name={avatar} />
        <h4>{name}</h4>
      </StyledUserInfoWrapper>
      <a href={url} target="_blank" rel="noreferrer">
        <Button size="medium" variant="secondary">{t('view_appointment')}</Button>
      </a>
    </StyledUserInfo>
  );
};

export default UserInfo;
